// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","footer__content":"Footer_footer__content__DNJER"};